function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#icon4_svg__filter0_d)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "M11.053 35.711V109.5M100 106.447H7.684"
}), /*#__PURE__*/React.createElement("rect", {
  x: 26.053,
  y: 88.605,
  width: 12.632,
  height: 6.737,
  rx: 3.368,
  transform: "rotate(90 26.053 88.605)",
  fill: "url(#icon4_svg__paint0_linear)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 93.421,
  y: 46.5,
  width: 54.737,
  height: 6.737,
  rx: 3.368,
  transform: "rotate(90 93.42 46.5)",
  fill: "url(#icon4_svg__paint1_linear)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 39.526,
  y: 80.184,
  width: 21.053,
  height: 6.737,
  rx: 3.368,
  transform: "rotate(90 39.526 80.184)",
  fill: "url(#icon4_svg__paint2_linear)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 53,
  y: 71.763,
  width: 29.474,
  height: 6.737,
  rx: 3.368,
  transform: "rotate(90 53 71.763)",
  fill: "url(#icon4_svg__paint3_linear)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 66.474,
  y: 63.342,
  width: 37.895,
  height: 6.737,
  rx: 3.368,
  transform: "rotate(90 66.474 63.342)",
  fill: "url(#icon4_svg__paint4_linear)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 79.947,
  y: 55.763,
  width: 45.474,
  height: 6.737,
  rx: 3.368,
  transform: "rotate(90 79.947 55.763)",
  fill: "url(#icon4_svg__paint5_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.14 70.116a1 1 0 00-.28 1.98l.28-1.98zm72.367-39.99a1 1 0 00-1.301-.554l-8.35 3.36a1 1 0 10.747 1.855l7.422-2.986 2.985 7.422a1 1 0 101.856-.747l-3.36-8.35zm-63.08 40.637a66.7 66.7 0 01-9.288-.647l-.278 1.98c3.126.44 6.32.667 9.565.667v-2zm61.232-40.655C65.466 54.023 41.883 70.763 14.426 70.763v2c28.293 0 52.58-17.251 63.073-41.87l-1.84-.785z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon4_svg__paint0_linear",
  x1: 26.053,
  y1: 91.974,
  x2: 40.368,
  y2: 91.974,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.917,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon4_svg__paint1_linear",
  x1: 93.421,
  y1: 49.868,
  x2: 155.456,
  y2: 49.868,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.917,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon4_svg__paint2_linear",
  x1: 39.526,
  y1: 83.553,
  x2: 63.386,
  y2: 83.553,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.917,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon4_svg__paint3_linear",
  x1: 53,
  y1: 75.132,
  x2: 86.403,
  y2: 75.132,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.917,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon4_svg__paint4_linear",
  x1: 66.474,
  y1: 66.71,
  x2: 109.421,
  y2: 66.711,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.917,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon4_svg__paint5_linear",
  x1: 79.947,
  y1: 59.132,
  x2: 131.484,
  y2: 59.132,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.917,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("filter", {
  id: "icon4_svg__filter0_d",
  x: 0,
  y: 29.5,
  width: 105,
  height: 89,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

function SvgIcon4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 140,
    viewBox: "0 0 145 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,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";
export { SvgIcon4 as ReactComponent };